// Single source of truth for Intl / dayjs locale.
//
// Frozen to ``en-GB`` because the product UI is English-only and en-GB gives
// us the European norms a Witailer/Alkemy reader expects out of the box:
//   * DD/MM/YYYY dates (no AM/PM, no MM/DD ambiguity)
//   * EUR currency symbol on the right (``1.234,56 €`` style) is NOT used —
//     en-GB renders ``€1,234.56`` with a leading symbol, which matches the
//     prevalent screenshot style for cross-tenant Alkemy reports.
//   * Thousands grouped by comma; decimal dot — the format every embedded
//     mono-font numeric column in the app was already designed around.
//
// Centralised so we never grep for a stray ``'it-IT'`` again. Use:
//   new Intl.NumberFormat(LOCALE, …)
//   date.toLocaleDateString(LOCALE)
//   dayjs.locale('en-gb')   // dayjs uses lowercase
export const LOCALE = 'en-GB' as const;

// Numbers follow the Italian convention the readers use (1.411.757 · 12,5%),
// with the € symbol in front, while dates and copy stay en-GB. de-DE rather
// than it-IT: same separators, but it-IT leaves 4-digit numbers ungrouped
// ("1234" next to "12.345"). All number formatting goes through
// lib/formatting, which prepends the € itself.
export const NUMBER_LOCALE = 'de-DE' as const;
export const DAYJS_LOCALE = 'en-gb' as const;
